import axios from 'axios'
import vue from 'vue'
import router from '../router/index'
import store from '../store'

vue.use(store)

// 创建axios实例
const service = axios.create({
  // baseURL:'http://ww.miweiculture.com/prod-api/',
  baseURL: 'http://219.142.112.176/prod-api',
  timeout: 1000 * 300,
  // withCredentials: false,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'Cache-Control': 'no-cache',
    'Accept': '*/*'
  }
})

// 请求拦截器
service.interceptors.request.use(config => {
  if (!localStorage.getItem('token')){
    store.state.isLogin = false
  }
  return config
}, error => {
  console.log('请求拦截器err：' + error);
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
    response => {
        const code = response.data.code || 200;
        if (code === 401) {
          console.log('未登录');
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('isLogin')
          store.state.isLogin = false
          // router.push('/')
        }
        return response;
        // 未设置状态码则默认成功状态
        // // 获取错误信息
        // const errorCode = {
        //     '401': '认证失败，无法访问系统资源',
        //     '403': '当前操作没有权限',
        //     '404': '访问资源不存在',
        //     'default': '系统未知错误,请反馈给管理员'
        // };
        // const msg = errorCode[code] || response.data.msg || errorCode['default'];
        // if (code === 500) {
        //     return Promise.reject(new Error(msg))
        // } else if (code !== 200) {
        //     return Promise.reject('error')
        // }else{
        //     return response.data
        // }
    },
    error => {
        console.log('err：' + error);
        let { message } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        }
        else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        }
        else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        // router.push('/')
        return Promise.reject(message);
    }
)
export default service;